// import { ApiMananger } from "../../../../redux/apiMananger";
// import API from "../../../../routes/api.routes";

// const noteApi = ApiMananger.injectEndpoints({
//   endpoints: (build) => ({
//     getKpis: build.query({
//       query: () => API.KPI.GETALL(),
//       providesTags: ["Kpi"],
//     }),
//   }),
// });

// export const { useGetKpisQuery } = noteApi;
import { ApiMananger } from "../../../../redux/apiMananger";
import API from "../../../../routes/api.routes";

const noteApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getKpis: build.query({
      query: (params = {}) => {
        const queryParams = new URLSearchParams();

        if (params.filter) queryParams.append('filter', params.filter);
        if (params.month_name) queryParams.append('month_name', params.month_name);
        if (params.year) queryParams.append('year', params.year);
        if (params.start_date) queryParams.append('start_date', params.start_date);
        if (params.end_date) queryParams.append('end_date', params.end_date);

        const queryString = queryParams.toString();
        return queryString
          ? `${API.KPI.GETALL()}?${queryString}`
          : API.KPI.GETALL();
      },
      providesTags: ["Kpi"],
    }),
    getFeatureUsageStats: build.query({
      query: (params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.start_date) queryParams.append('start_date', params.start_date);
        if (params.end_date) queryParams.append('end_date', params.end_date);
        if (params.group_by) queryParams.append('group_by', params.group_by);
        if (params.parent_id) queryParams.append('parent_id', params.parent_id);
        const qs = queryParams.toString();
        return qs ? `feature-usage/stats/?${qs}` : 'feature-usage/stats/';
      },
      providesTags: ["FeatureUsage"],
    }),
  }),
});

export const { useGetKpisQuery, useGetFeatureUsageStatsQuery } = noteApi;